<div class="gen-toast" [class.visible]="visible" *ngIf="event">
  <div class="gen-toast-header">
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
    <span class="gen-toast-label">{{ event.label }}</span>
    <button class="gen-toast-close" (click)="dismiss()">×</button>
  </div>

  <div class="gen-toast-body">
    <div class="gen-toast-stat">
      <span class="stat-label">Crediti usati</span>
      <strong class="stat-value credits">-{{ formatCredits(event.creditCost) }}</strong>
    </div>
    <div class="gen-toast-divider" *ngIf="event.balanceCredits != null"></div>
    <div class="gen-toast-stat" *ngIf="event.balanceCredits != null">
      <span class="stat-label">Saldo residuo</span>
      <strong class="stat-value">{{ formatCredits(event.balanceCredits) }}</strong>
    </div>
  </div>
</div>
